exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pendingSSOPage .opHeader{text-align:center;font-weight:700}.pendingSSOPage .accountFields input{margin-bottom:12.5px}.pendingSSOPage .bigOr{text-align:center;margin-top:12px;margin-bottom:12px;font-size:2rem}.pendingSSOPage .choice{position:relative;width:80%;margin-left:10%;margin-top:15px}.pendingSSOPage .option{display:inline-block;vertical-align:top;width:45%}.pendingSSOPage .option.small{width:10%}.pendingSSOPage .option button{margin:0 auto;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/technical/pending_sso_page.scss
// module id = 1418
// module chunks = 0